var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBarcodeScanning = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#86A7B2",
  d: "M2.9 22.2c-.8 0-1.5-.7-1.5-1.5v-4.2c0-.3.2-.5.5-.5s.5.2.5.5v4.2c0 .3.2.5.5.5h4.2c.3 0 .5.2.5.5s-.2.5-.5.5zM1.9 10c-.3 0-.5-.2-.5-.5V5.3c0-.8.7-1.5 1.5-1.5h4.2c.3 0 .5.2.5.5s-.3.5-.5.5H2.9c-.3 0-.5.2-.5.5v4.2c0 .3-.2.5-.5.5M23.1 22.2h-4.2c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h4.2c.3 0 .5-.2.5-.5v-4.2c0-.3.2-.5.5-.5s.5.2.5.5v4.2c0 .8-.7 1.5-1.5 1.5M24.1 10c-.3 0-.5-.2-.5-.5V5.3c0-.3-.2-.5-.5-.5h-4.2c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h4.2c.8 0 1.5.7 1.5 1.5v4.2c0 .3-.2.5-.5.5"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#00CFB3",
  d: "M22.6 15.7H3.7c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h18.9c.3 0 .5.2.5.5s-.3.5-.5.5"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#D5EBEF",
  d: "M4.6 6.9h2v6.7h-2zM14.4 6.9h3v6.7h-3zM12.2 6.9h1v6.7h-1zM7.9 6.9h.5v6.7h-.5zM10.1 6.9h.5v6.7h-.5zM18.5 6.9h1v6.7h-1zM20.9 6.9h.5v6.7h-.5z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#86A7B2",
  d: "M4.6 16.7h2v2.6h-2zM14.4 16.7h3v2.6h-3zM12.2 16.7h1v2.6h-1zM7.9 16.7h.5v2.6h-.5zM10.1 16.7h.5v2.6h-.5zM18.5 16.7h1v2.6h-1zM20.9 16.7h.5v2.6h-.5z"
})));
export default SvgBarcodeScanning;